export default {
  categories: {
    shoes: 'Zapatos',
    hoodies: 'Sudaderas / Suéteres',
    tshirts: 'Camisetas',
    jackets: 'Chaquetas',
    pants: 'Pantalones / Pantalones cortos',
    headwear: 'Gorros y sombreros',
    sets: 'Conjuntos',
    underwear: 'Ropa interior',
    jersey: 'Camisetas deportivas',
    accessories: 'Accesorios',
    bags: 'Bolsos',
    belts: 'Cinturones',
    perfumes: 'Perfumes',
    other: 'Otros artículos',
  },
};